// constants/servicesMapping.js
export const ServicesMapping = {
  // Brand Profile Management
  "BrandProfileManagement": {
    serviceName: "Brand Profile Management",
    templates: ["BrandProfileManagement"],
    fields: [
      {
        name: "BrandProfileCost",
        label: "Monthly Cost (2 Platforms)",
        type: "number",
        priceField: true,
        required: true
      },
      {
        name: "BrandProfilePlanCost",
        label: "6-Month Plan Total",
        type: "number",
        priceField: true,
        required: true
      },
      {
        name: "BrandProfilePlanCostPerMonth",
        label: "Effective Monthly Cost",
        type: "number",
        derived: true,
        readOnly: true
      },
      {
        name: "BrandProfileAdBudget",
        label: "Ad Budget",
        type: "number",
        priceField: true
      }
    ],
    calculateDerived: (values) => ({
      BrandProfilePlanCostPerMonth: values.BrandProfilePlanCost ? values.BrandProfilePlanCost / 6 : 0
    }),
    calculateServiceTotal: (fields) => {
      return (parseFloat(fields.BrandProfilePlanCost) || 0) + (parseFloat(fields.BrandProfileAdBudget) || 0);
    }
  },

  // Founders LinkedIn Management
  "FoundersLinkedInManagement": {
    serviceName: "Founders LinkedIn Management",
    templates: ["FoundersLinkedInManagement"],
    fields: [
      {
        name: "BasicCost",
        label: "Basic Plan Monthly",
        type: "number",
        priceField: true
      },
      {
        name: "Basic6MonthCost",
        label: "Basic Plan (6 Months)",
        type: "number",
        priceField: true,
        required: true
      },
      {
        name: "BasicCostPerMonth",
        label: "Basic Effective Monthly",
        type: "number",
        derived: true,
        readOnly: true
      },
      {
        name: "GrowthCost",
        label: "Growth Plan Monthly",
        type: "number",
        priceField: true
      },
      {
        name: "Growth6MonthCost",
        label: "Growth Plan (6 Months)",
        type: "number",
        priceField: true,
        required: true
      },
      {
        name: "GrowthCostPerMonth",
        label: "Growth Effective Monthly",
        type: "number",
        derived: true,
        readOnly: true
      }
    ],
    calculateDerived: (values) => ({
      BasicCostPerMonth: values.Basic6MonthCost ? values.Basic6MonthCost / 6 : 0,
      GrowthCostPerMonth: values.Growth6MonthCost ? values.Growth6MonthCost / 6 : 0
    }),
    calculateServiceTotal: (fields) => {
      return parseFloat(fields.Basic6MonthCost) || parseFloat(fields.Growth6MonthCost) || 0;
    }
  },

  // Lead Generation
  "LeadGen": {
    serviceName: "Lead Generation",
    templates: ["LeadGen"],
    fields: [
      {
        name: "CampaignManagementMonthly",
        label: "Campaign Management Monthly",
        type: "number",
        priceField: true
      },
      {
        name: "CampaignManagementThreeMonths",
        label: "Campaign Management (3 Months)",
        type: "number",
        priceField: true,
        required: true
      },
      {
        name: "CampaignManagementPerMonth",
        label: "Effective Monthly Cost",
        type: "number",
        derived: true,
        readOnly: true
      },
      {
        name: "AdBudgetMonthly",
        label: "Monthly Ad Budget",
        type: "number",
        priceField: true
      },
      {
        name: "FunnelDesignCost",
        label: "Funnel Design Cost",
        type: "number",
        priceField: true
      }
    ],
    calculateDerived: (values) => ({
      CampaignManagementPerMonth: values.CampaignManagementThreeMonths ? values.CampaignManagementThreeMonths / 3 : 0
    }),
    calculateServiceTotal: (fields) => {
      return (parseFloat(fields.CampaignManagementThreeMonths) || 0) +
        (parseFloat(fields.AdBudgetMonthly) || 0) +
        (parseFloat(fields.FunnelDesignCost) || 0);
    }
  },

  // LinkedIn Company Profile
  "LinkedInCompanyProfile": {
    serviceName: "LinkedIn Company Profile",
    templates: ["LinkedInCompanyProfile"],
    fields: [
      {
        name: "BasicCost",
        label: "Basic Plan Monthly",
        type: "number",
        priceField: true
      },
      {
        name: "Basic6MonthCost",
        label: "Basic Plan (6 Months)",
        type: "number",
        priceField: true,
        required: true
      },
      {
        name: "BasicCostPerMonth",
        label: "Basic Effective Monthly",
        type: "number",
        derived: true,
        readOnly: true
      },
      {
        name: "GrowthCost",
        label: "Growth Plan Monthly",
        type: "number",
        priceField: true
      },
      {
        name: "Growth6MonthCost",
        label: "Growth Plan (6 Months)",
        type: "number",
        priceField: true,
        required: true
      },
      {
        name: "GrowthCostPerMonth",
        label: "Growth Effective Monthly",
        type: "number",
        derived: true,
        readOnly: true
      },
      {
        name: "VideoShootCost",
        label: "Video Shoot Cost",
        type: "number",
        priceField: true
      }
    ],
    calculateDerived: (values) => ({
      BasicCostPerMonth: values.Basic6MonthCost ? values.Basic6MonthCost / 6 : 0,
      GrowthCostPerMonth: values.Growth6MonthCost ? values.Growth6MonthCost / 6 : 0
    }),
    calculateServiceTotal: (fields) => {
      return (parseFloat(fields.Basic6MonthCost) || parseFloat(fields.Growth6MonthCost) || 0) +
        (parseFloat(fields.VideoShootCost) || 0);
    }
  },

  // Personal Branding
  "PersonalBranding": {
    serviceName: "Personal Branding",
    templates: ["PersonalBranding"],
    fields: [
      {
        name: "TwoPlatformCost",
        label: "2 Platforms Monthly",
        type: "number",
        priceField: true
      },
      {
        name: "TwoPlatform6MonthCost",
        label: "2 Platforms (6 Months)",
        type: "number",
        priceField: true,
        required: true
      },
      {
        name: "TwoPlatformPerMonth",
        label: "2 Platforms Effective Monthly",
        type: "number",
        derived: true,
        readOnly: true
      },
      {
        name: "ThreePlatformCost",
        label: "3 Platforms Monthly",
        type: "number",
        priceField: true
      },
      {
        name: "ThreePlatform6MonthCost",
        label: "3 Platforms (6 Months)",
        type: "number",
        priceField: true,
        required: true
      },
      {
        name: "ThreePlatformPerMonth",
        label: "3 Platforms Effective Monthly",
        type: "number",
        derived: true,
        readOnly: true
      },
      {
        name: "OutdoorShootCost",
        label: "Outdoor Shoot Cost",
        type: "number",
        priceField: true
      },
      {
        name: "VideoShootValue",
        label: "Video Shoot Value",
        type: "number",
        priceField: true
      },
      {
        name: "AdvancePaymentDiscount",
        label: "Advance Payment Discount (%)",
        type: "number"
      }
    ],
    calculateDerived: (values) => ({
      TwoPlatformPerMonth: values.TwoPlatform6MonthCost ? values.TwoPlatform6MonthCost / 6 : 0,
      ThreePlatformPerMonth: values.ThreePlatform6MonthCost ? values.ThreePlatform6MonthCost / 6 : 0
    }),
    calculateServiceTotal: (fields) => {
      return (parseFloat(fields.TwoPlatform6MonthCost) || parseFloat(fields.ThreePlatform6MonthCost) || 0) +
        (parseFloat(fields.OutdoorShootCost) || 0);
    }
  },

  // Podcast Services
  "MarathiPodcast": {
    serviceName: "The Marathi Podcast",
    templates: ["MarathiPodcast"],
    fields: [
      {
        name: "ParticipationFee",
        label: "Participation Fee",
        type: "number",
        priceField: true,
        required: true
      },
      {
        name: "ExtraReelCost",
        label: "Extra Reel Cost",
        type: "number",
        priceField: true
      },
      {
        name: "ExtraReelCollabCost",
        label: "Extra Reel + Collaboration",
        type: "number",
        priceField: true
      },
      {
        name: "GiveawayCost",
        label: "Giveaway Cost",
        type: "number",
        priceField: true
      },
      {
        name: "CommunityPostCost",
        label: "Community Post Cost",
        type: "number",
        priceField: true
      }
    ],
    calculateDerived: (values) => ({}),
    calculateServiceTotal: (fields) => {
      return (parseFloat(fields.ParticipationFee) || 0) +
        (parseFloat(fields.ExtraReelCost) || 0) +
        (parseFloat(fields.ExtraReelCollabCost) || 0) +
        (parseFloat(fields.GiveawayCost) || 0) +
        (parseFloat(fields.CommunityPostCost) || 0);
    }
  },

  "SnehyogaPodcast": {
    serviceName: "Snehyoga Podcast",
    templates: ["SnehyogaPodcast"],
    fields: [
      {
        name: "ParticipationFee",
        label: "Participation Fee",
        type: "number",
        priceField: true,
        required: true
      },
      {
        name: "ExtraReelCost",
        label: "Extra Reel Cost",
        type: "number",
        priceField: true
      },
      {
        name: "GiveawayCost",
        label: "Giveaway Cost",
        type: "number",
        priceField: true
      },
      {
        name: "CommunityPostCost",
        label: "Community Post Cost",
        type: "number",
        priceField: true
      }
    ],
    calculateDerived: (values) => ({}),
    calculateServiceTotal: (fields) => {
      return (parseFloat(fields.ParticipationFee) || 0) +
        (parseFloat(fields.ExtraReelCost) || 0) +
        (parseFloat(fields.GiveawayCost) || 0) +
        (parseFloat(fields.CommunityPostCost) || 0);
    }
  },

  "ShwetaBodheMore": {
    serviceName: "Shweta Bodhe More",
    templates: ["ShwetaBodheMore"],
    fields: [
      {
        name: "ParticipationFee",
        label: "Participation Fee",
        type: "number",
        priceField: true,
        required: true
      },
      {
        name: "ExtraReelCost",
        label: "Extra Reel Cost",
        type: "number",
        priceField: true
      },
      {
        name: "GiveawayCost",
        label: "Giveaway Cost",
        type: "number",
        priceField: true
      },
      {
        name: "CommunityPostCost",
        label: "Community Post Cost",
        type: "number",
        priceField: true
      }
    ],
    calculateDerived: (values) => ({}),
    calculateServiceTotal: (fields) => {
      return (parseFloat(fields.ParticipationFee) || 0) +
        (parseFloat(fields.ExtraReelCost) || 0) +
        (parseFloat(fields.GiveawayCost) || 0) +
        (parseFloat(fields.CommunityPostCost) || 0);
    }
  },

  "NikhilMawaleShow": {
    serviceName: "THE NIKHIL MAWALE SHOW",
    templates: ["NikhilMawaleShow"],
    fields: [
      {
        name: "ParticipationFee",
        label: "Participation Fee",
        type: "number",
        priceField: true,
        required: true
      },
      {
        name: "ExtraReelCost",
        label: "Extra Reel Cost",
        type: "number",
        priceField: true
      },
      {
        name: "GiveawayCost",
        label: "Giveaway Cost",
        type: "number",
        priceField: true
      },
      {
        name: "CommunityPostCost",
        label: "Community Post Cost",
        type: "number",
        priceField: true
      }
    ],
    calculateDerived: (values) => ({}),
    calculateServiceTotal: (fields) => {
      return (parseFloat(fields.ParticipationFee) || 0) +
        (parseFloat(fields.ExtraReelCost) || 0) +
        (parseFloat(fields.GiveawayCost) || 0) +
        (parseFloat(fields.CommunityPostCost) || 0);
    }
  }
};

export const ServiceOptions = [
  { value: "BrandProfileManagement", label: "Brand Profile Management" },
  { value: "FoundersLinkedInManagement", label: "Founders LinkedIn Management" },
  { value: "LeadGen", label: "Lead Generation" },
  { value: "LinkedInCompanyProfile", label: "LinkedIn Company Profile" },
  { value: "PersonalBranding", label: "Personal Branding" },
  { value: "MarathiPodcast", label: "The Marathi Podcast" },
  { value: "SnehyogaPodcast", label: "Snehyoga Podcast" },
  { value: "ShwetaBodheMore", label: "Shweta Bodhe More" },
  { value: "NikhilMawaleShow", label: "THE NIKHIL MAWALE SHOW" }
];

export const getTemplatesByService = (service) => {
  return ServicesMapping[service]?.templates || [];
};

export const getFieldsByServiceAndTemplate = (service, template) => {
  if (ServicesMapping[service]) {
    return ServicesMapping[service].fields;
  }
  return [];
};